import { render, staticRenderFns } from "./HeaderNavbarAction.vue?vue&type=template&id=12460bc8&"
import script from "./HeaderNavbarAction.vue?vue&type=script&lang=js&"
export * from "./HeaderNavbarAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports